<template>
    <div class="wrapper section_wrapper section_information_wrapper">
        <div class="container">
            <div class="section_title" v-if="current_page['page_title']"><h1>{{ current_page['page_title'] }}</h1></div>
            <div class="section_information_container column_wrapper" :class="{ mobile_show_menu:mobile_show_menu(), mobile_show_content:current_page.type&&current_page.type==='sub_page' }">
                <div class="section_information_menu menu_container column_container">
                    <div v-for="menu_item in left_menu" class="menu_item" :class="{ active:menu_item.page_id===$root.current_id.page, mobile_show_menu_item:menu_item===parent_menu_item }">
                        <a href="javascript:void(0)" @click="set_active(menu_item)"><span>{{ menu_item.display_name }}</span></a>
                        <div v-if="menu_item._ref_list_children" class="sub_menu_container">
                            <div v-for="sub_menu_item in menu_item._ref_list_children" class="sub_menu_item" :class="{ active:sub_menu_item.page_id===$root.current_id.page }">
                                <a href="javascript:void(0)" @click="set_active(sub_menu_item)"><span>{{ sub_menu_item.display_name }}</span></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column_separator"></div>
                <div class="section_information_content column_container">
                    <div class="sub_title"><h2>{{ current_page['display_name'] }}</h2></div>
                    <div class="sub_content" v-html="current_page['content']"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ContentWithLeftMenu',
        data() {
            let current_object = this;
            let root = current_object.$root;
            let data_set = {
                current_menu_item:null,
                parent_menu_item:null,
                current_page:{
                    display_name:'Blank Resource Page',
                    content:'<p>Hello World</p>'
                },
                left_menu:[]
            };
            if (root.current_id.page && root.item_map) {
                if (root.item_map.page && root.item_map.page[root.current_id.page]) {
                    data_set.current_page = root.item_map.page[root.current_id.page];
                    if (data_set.current_page._ref_left_menu) {
                        data_set.left_menu = data_set.current_page._ref_left_menu._ref_list_children;
                        if (data_set.left_menu) {
                            data_set.left_menu.forEach(function (menu_item) {
                                // console.log(menu_item.page_id,root.current_id.page,menu_item.page_id === root.current_id.page);
                                if (menu_item.page_id === root.current_id.page) {
                                    data_set.current_menu_item = menu_item;
                                    data_set.parent_menu_item = menu_item;
                                } else {
                                    if (menu_item._ref_list_children) {
                                        menu_item._ref_list_children.forEach(function (sub_menu_item) {
                                            if (sub_menu_item.page_id === root.current_id.page) {
                                                data_set.current_menu_item = sub_menu_item;
                                                data_set.parent_menu_item = menu_item;
                                            }
                                        });
                                    }
                                }
                            });
                        }

                    }
                }
            }
// console.log('allen debug Resources current_page',data_set.current_page,data_set.left_menu);
            // if (root.item_list && data_set.current_page['left_menu_name'] && root.item_list[data_set.current_page['left_menu_name']]) {
            //     data_set.left_menu = root.item_list[data_set.current_page['left_menu_name']][0]._ref_list_children;
            //     data_set.left_menu.forEach(function (menu_item) {
            //         console.log(menu_item.page_id,root.current_id.page,menu_item.page_id === root.current_id.page);
            //         if (menu_item.page_id === root.current_id.page) {
            //             data_set.current_menu_item = menu_item;
            //             data_set.parent_menu_item = menu_item;
            //         } else {
            //             if (menu_item._ref_list_children) {
            //                 menu_item._ref_list_children.forEach(function (sub_menu_item) {
            //                     if (sub_menu_item.page_id === root.current_id.page) {
            //                         data_set.current_menu_item = sub_menu_item;
            //                         data_set.parent_menu_item = menu_item;
            //                     }
            //                 });
            //             }
            //         }
            //     });
            //
            // }
// console.log('allen debug current_menu_item',data_set.current_menu_item,data_set.parent_menu_item,root.current_id.page);
            return data_set;
        },
        mounted() {
            $('.expandable_image_container .expand_trigger').on('click', function () {
                let expand_parent = $(this).closest('.expandable_image_container');
                let expand_wrapper = expand_parent.children('.expand_wrapper');
                if (expand_parent.hasClass('expand_parent_expanded')) {
                    expand_wrapper.animate({
                        height: 0
                    },500,function () {
                        expand_parent.removeClass('expand_parent_expanded')
                    });
                } else {
                    expand_wrapper.animate({
                        height: expand_wrapper.children('.expand_container').outerHeight()
                    },500,function () {
                        expand_parent.addClass('expand_parent_expanded')
                    });
                }
            });
        },
        computed: {

        },
        methods: {
            set_active: function (menu_item) {
                // console.log('allen debug LeftMenu set_active', menu_item);
                if (!menu_item.page_id && menu_item.description) {
                    location.replace(menu_item.description);
                }
                let target_menu_item = menu_item;
                while ((!target_menu_item._ref_page || !target_menu_item._ref_page.content) && target_menu_item._ref_list_children) {
                    // Redirect to 1st child if page content is empty
                    target_menu_item = target_menu_item._ref_list_children[0];
                }

                this.$root.set_page(target_menu_item.page_id);
                // console.log('allen debug TopMenu set_active end', menu_item);
            },
            mobile_show_menu: function () {
                let current_object = this;
                if (!current_object.parent_menu_item) {
                    return true;
                }
                if (!current_object.parent_menu_item._ref_list_children) {
                    return false;
                }
                if (!current_object.parent_menu_item._ref_list_children.length) {
                    return false;
                }

                return true;
            }
        }
    }
</script>